import { http, HttpResponse } from 'msw';

import { env } from '@/config/env';
import { axios } from '@/lib/axios';
import { networkDelay } from '@/test/mocks/utils';

import { GenerateRoom } from '../types';

export const generateRoom = (roomId: string): Promise<GenerateRoom.Root> => {
  return axios.get(`/assessment/v1/users/rooms/generate-room/${roomId}`);
};

export const generateRoomMockHandler = http.get(
  `${env.API_URL}/assessment/v1/users/rooms/generate-room/:roomId`,
  async (): Promise<HttpResponse<GenerateRoom.Root>> => {
    await networkDelay();

    const mockResponse: GenerateRoom.Root = {
      status: 'success',
      responseBody: {
        roomId: 'c486b004-cd8f-4e9c-bbaa-ced26032df79',
      },
      errorCode: 0,
      errorMessage: null,
    };

    return HttpResponse.json(mockResponse);
  }
);
